// package: users
// file: user-shared.proto

var user_shared_pb = require("./user-shared_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var UserSharedApiService = (function () {
  function UserSharedApiService() {}
  UserSharedApiService.serviceName = "users.UserSharedApiService";
  return UserSharedApiService;
}());

UserSharedApiService.getNotificationSettings = {
  methodName: "getNotificationSettings",
  service: UserSharedApiService,
  requestStream: false,
  responseStream: false,
  requestType: user_shared_pb.GetNotificationSettingsRequest,
  responseType: user_shared_pb.NotificationSettingsContainer
};

UserSharedApiService.setNotificationSetting = {
  methodName: "setNotificationSetting",
  service: UserSharedApiService,
  requestStream: false,
  responseStream: false,
  requestType: user_shared_pb.SetNotificationSettingsRequest,
  responseType: google_protobuf_empty_pb.Empty
};

exports.UserSharedApiService = UserSharedApiService;

function UserSharedApiServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

UserSharedApiServiceClient.prototype.getNotificationSettings = function getNotificationSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserSharedApiService.getNotificationSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserSharedApiServiceClient.prototype.setNotificationSetting = function setNotificationSetting(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserSharedApiService.setNotificationSetting, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.UserSharedApiServiceClient = UserSharedApiServiceClient;

